<template>
  <div class="line-chart f-r f-c">
    <div class="unit">单位：{{ unit }}</div>
    <div class="chart-canvas">
      <VChart
        style="width: 100%; height: 100%"
        :option="option"
        autoresize
      ></VChart>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import chartTipsImage from "@/assets/tips2.png";
const getLineLabel = () => {
  return {
    show: false,
    animation: false,
    formatter: (params) => {
      return params.value;
    },
    backgroundColor: {
      image: chartTipsImage,
    },
    color: "#fff",
    padding: [8, 11, 14, 11],
    distance: 0,
    fontSize: 14,
  };
};

const getLineSymbol = () => {
  return "image://data:image/png;base64,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";
};
const props = defineProps({
  unit: String,
  xData: {
    type: Array,
    default: () => [],
  },
  yData: {
    type: Array,
    default: () => [],
  },
});

const option = computed(() => {
      return {
        color: ["#000"],
        grid: {
          top: 45,
          left: 0,
          right: 0,
          bottom: 20,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: props.xData,
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "rgba(0,0,0,0.45)",
          },
          axisLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(0,0,0,0.15)",
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(0,0,0,0.15)",
            },
          },
        },
        series: {
          type: "line",
          smooth: true,
          symbol: "circle",
          lineStyle: {
            width: 6,
            cap: "round",
          },
          triggerLineEvent: true,
          data: props.yData.map((value, valueIndex) => {
            let show = valueIndex === props.yData.length - 1;
            return {
              name: props.xData[valueIndex],
              value: value,
              symbolSize: show ? 24 : 60,
              symbol: show ? getLineSymbol() : "circle",
              label: {
                ...getLineLabel(),
                show,
              },
              itemStyle: {
                color: "transparent",
              },
            };
          }),
        },
      };
    });
</script>

<style lang="less">
.line-chart {
  padding: 12px;
  background: #f6f7fa;
  .unit {
    width: 100%;
    text-align: right;
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
  }
  .chart-canvas {
    flex-grow: 1;
  }
}
</style>
